const LOCALE = "nb-NO";
const CURRENCY = "NOK";
const NOK_PER_MIN_EST = 29; // grovt anslag for beregning av minutter av saldo

export function maskCard(last4: string) {
    return `•••• •••• •••• ${last4 || "0000"}`;
}
export function fmtDate(iso: string) {
    try {
        const d = new Date(iso);
        return new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium", timeStyle: "short" }).format(d);
    } catch {
        return iso;
    }
}
export function fmtDuration(mins: number) {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (h && m) return `${h} t ${m} min`;
    if (h) return `${h} t`;
    return `${m} min`;
}
export function estimateMinutes(nok: number, rateNokPerMin = NOK_PER_MIN_EST) {
    if (!rateNokPerMin) return 0;
    return Math.max(0, Math.floor(nok / rateNokPerMin));
}

/** Format MM:SS */
export function formatTime(sec) {
    const m = Math.floor(sec / 60).toString().padStart(2, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
};

export function parseUntilObject(data) {
    if (typeof data !== "object") {
        try {
            data = JSON.parse(data);
            return parseUntilObject(data);
        } catch (e) {
            throw new Error("Data cannot be parsed to an object");
        }
    }
    return data;
}

// helper to build display pic URL
export function getAgentDisplayPicUrl(pic: string | null, base: string) {
    const isLocal = base.includes("localhost") || base === "";
    if (!pic) {
        return isLocal
            ? "https://localhost/chamcore/chameleon/assets/front-users/media/users/blank.png"
            : "https://chamcore.com/chameleon/assets/front-users/media/users/blank.png";
    }
    return isLocal
        ? `https://localhost/chamcore/chameleon/uploads/agent/${pic}`
        : `https://chamcore.com/chameleon/uploads/agent/${pic}`;
};
